import { ThemeEvents } from '@theme/events';

/**
 * <installment-card>
 *
 * Variant değişiminde kendini section'ın re-render edilmiş HTML'inden bulup
 * iç içeriğini günceller. wire-discount-card deseniyle birebir aynı.
 */
class InstallmentCard extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    if (this.section) {
      this.section.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
    }
  }

  handleVariantUpdate = (event) => {
    const detail = event.detail ?? {};
    const data = detail.data ?? {};

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const html = data.html;
    if (!html) return;

    const replacement = html.querySelector(`installment-card[data-block-id="${this.dataset.blockId}"]`);
    if (!replacement) {
      this.hidden = true;
      return;
    }

    const newInner = replacement.querySelector('[data-installment-root]');
    const currentInner = this.querySelector('[data-installment-root]');
    if (!newInner || !currentInner) return;

    this.hidden = false;
    currentInner.replaceWith(newInner);

    this.dataset.installmentUpdating = 'true';
    window.setTimeout(() => {
      delete this.dataset.installmentUpdating;
    }, 450);
  };
}

if (!customElements.get('installment-card')) {
  customElements.define('installment-card', InstallmentCard);
}
